import $ from 'jquery';
import Swal from 'sweetalert2';

export default function() 
{
  selectVariant();

}

function selectVariant()
{
  $(document).on('click', '.js-select-variant', function(e) {
    
    if($(this).data('variant-type') == 'integration_color'){
      e.preventDefault();
      $('.js-select-variant[data-variant-type=integration_color]').parent().removeClass('selected');
    }
    
    if($(this).data('variant-type') == 'integration_size'){
      $('.js-select-variant[data-variant-type=integration_size]').parent().removeClass('selected');
    }

    const variantType = $(this).data('variant-type');
    const variantValue = $(this).data('variant-value');
    const productXmlID = $(this).data('product-id');
    const variantID = $(this).data('variant-id');
    const href = $(this).attr('href');
    
    if(variantType == 'integration_size' && !$('.js-select-variant[data-variant-type=integration_color]').parent().hasClass('selected'))
    {
      Swal.fire('Uyarı', 'Önce renk seçmeniz gerekmektedir', 'warning');
      return false;
    }

    $(this).parent().addClass('selected');
  })
}